import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyDOu26IidmnuEwkEJbCl-1ow4H8H6ikpos",
    authDomain: "rcmms--student-site.firebaseapp.com",
    databaseURL: "https://rcmms--student-site.firebaseio.com",
    projectId: "rcmms--student-site",
    storageBucket: "rcmms--student-site.appspot.com",
    messagingSenderId: "614074013153",
    appId: "1:614074013153:web:469cf70e7e9345796eaea0",
    measurementId: "G-J330MNSNZ8"
};

const FirebaseApp = initializeApp(firebaseConfig);
export default FirebaseApp;